import React, { useEffect, useState } from 'react';
import { HeaderFooterWarpper } from 'all-in-one-web-header-footer';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { RouteParams } from '@interfaces/portal';
import { Lang } from '@interfaces/app';

interface HeaderProps {
  lang: Lang
}
const HeaderFooter: React.FC<HeaderProps> = (props) => {
    
    const history = useHistory();
    const { i18n } = useTranslation();
    const language = i18n.language;

    const [routerLang, setRouterLang] = useState<string>(props.lang);
    const [isLogin, setIsLogin] = useState(false);

    const convertHeaderFooterLanguage = (lang: string) => {
        switch (lang) {
          case "tc":
            return "chi";
          case "en":
            return "eng";
        }
    }

    function replaceLanguageInPath(pathname: string, newLang: string) {
        
        // 匹配路径中的第一个 tc 或 en
        const langRegex = /^\/(tc|en)/;
      
        if (langRegex.test(pathname)) {
          return pathname.replace(langRegex, `/${newLang}`);
        }

        return pathname;
    }

    const changeLanguage = () => {
        const { pathname } = history.location
        let redirectLang = '';
        switch (routerLang) {
          case "tc":
            redirectLang = "en";
            break;
          case "en":
            redirectLang = "tc";
            break;
        }
        // pick up [lang] route and replace that;
        history.replace(`${replaceLanguageInPath(pathname, redirectLang)}`);
        toggleLanguage(redirectLang);
        setRouterLang(redirectLang);
    }
    
    const toggleLanguage = (newLanguage: string) => {
        if (newLanguage !== i18n.language) {
          i18n.changeLanguage(newLanguage);
        }
    }

    const isWechatMiniProgram = () => {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('miniprogram') && ua.includes('micromessenger');
  };
    
  return (
    <>
        {!isWechatMiniProgram() ? (
            <HeaderFooterWarpper
                isLogin={isLogin}
                handleChangeLang={() => {
                    changeLanguage();
                }}
                onURLClick={(fullURL: string, path: string) => {
                    window.open(fullURL);
                }}
                aioURL={"http://www.hkbn.net/personal/"}
                myaccountURL={"http://www.hkbn.net/"}
                darkMode={false}
                disableLogin={true}
                headerChild={() => {
                    return <div></div>;
                }}
                isDev={REACT_APP_API_URL_ENV === 'uat' ? true : false}
                currentLang={convertHeaderFooterLanguage(routerLang)}
            >
                {props.children}
            </HeaderFooterWarpper>
        ) : (
            <>{props.children}</>
        )}
    </>
);
};

export default HeaderFooter;
